import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: CategoryFilter } = lazyloadHelper(
    () => import(/* webpackChunkName: "productspage" */ "./CategoryFilter"),
)

const { WithSuspense: CategoryFilterBase } = lazyloadHelper(
    () => import(/* webpackChunkName: "productspage" */ "./CategoryFilterBase"),
)

export { CategoryFilter, CategoryFilterBase }
